/**
 * @module language-utils
 */

/**
 * Retrieves the language attribute from the HTML element.
 *
 * @return {string} - Returns the language attribute value or an empty string if not found.
 */
function getLanguage() {
	return document.documentElement.getAttribute( 'lang' ) || '';
}

/**
 * Sets a CSS class based on the current language.
 * This function assumes the body exists in the DOM.
 */
function setLanguage() {
	const bodyElem = document.body;

	if ( getLanguage() === 'sv-SE' ) {
		bodyElem.classList.add( 'svSE' );
	} else {
		bodyElem.classList.add( 'enUS' );
	}
}

export { getLanguage, setLanguage };
